export default __webpack_public_path__ + "static/media/broken-robot.92471a15.webp";